import { StaffFilter } from './StaffFilter';
import { StaffList } from './StaffList';
import { StaffShow } from './StaffShow';

export const list = StaffList;
export const show = StaffShow;
export const filter = StaffFilter;
